import React from "react";
import SwiperCore, { Virtual, Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

SwiperCore.use([Virtual, Navigation, Pagination]);

const NewSlider = ({
  slides,
  slidesPerView,
  center,
  isLink,
  link,
  contentWidth,
  breakPoints,
  autoPlay,
  loopToggle,
  spaceBetween,
}) => {
  return (
    <Swiper
      slidesPerView={2}
      spaceBetween={spaceBetween}
      centeredSlides={center}
      navigation={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: autoPlay,
      }}
      modules={
        loopToggle
          ? [Autoplay, Pagination, Navigation]
          : [Pagination, Navigation]
      }
      breakpoints={breakPoints}
      loop={loopToggle}
    >
      {slides.map((slide, i) => (
        <SwiperSlide key={i}>
          {isLink ? (
            <Link to={link`${link}/${slide.id}`}>
              <img
                id={slide.id}
                src={slide.src}
                link={slide.l.Link}
                style={{ width: "100%", cursor: "pointer" }}
              />
            </Link>
          ) : (
            <a href={slide.link} target="_blank">
              <img
                id={slide.id}
                src={slide.src}
                style={{ width: contentWidth, cursor: "pointer" }}
              />
            </a>
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

NewSlider.defaultProps = {
  center: false,
  isLink: false,
  link: "/hisstori",
};

export default NewSlider;
